import { Reveal } from "@/components/Reveal";
import { TESTIMONIALS } from "@/data/site";

export const Testimonials = () => (
  <section data-testid="testimonials" className="relative py-32 sm:py-44 border-t border-white/5">
    <div className="max-w-screen-2xl mx-auto px-6 sm:px-10">
      <div className="flex items-end justify-between mb-16">
        <Reveal><p className="label">Stimmen</p></Reveal>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <figure data-testid={`testimonial-${i}`} className="hover-card h-full bg-[#111111] border border-white/10 p-8 flex flex-col justify-between min-h-[300px]">
              <span className="font-serif text-6xl text-[#d4c4a8] leading-none">“</span>
              <blockquote className="font-serif text-2xl leading-snug text-[#fafafa] mt-2">{t.quote}</blockquote>
              <figcaption className="mt-8 pt-4 border-t border-white/10">
                <p className="font-display uppercase tracking-[0.18em] text-sm text-[#fafafa]">{t.name}</p>
                <p className="text-xs text-[#71717a] mt-1">{t.role}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
